import { render, staticRenderFns } from "./IntegrationFormFields.vue?vue&type=template&id=4c5d8598&scoped=true"
import script from "./IntegrationFormFields.vue?vue&type=script&lang=js"
export * from "./IntegrationFormFields.vue?vue&type=script&lang=js"
import style0 from "./IntegrationFormFields.vue?vue&type=style&index=0&id=4c5d8598&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5d8598",
  null
  
)

export default component.exports